import gsap from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { Maths } from '../_app/cuchillo/utils/Maths';

import Default from './Default';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';

export default class About extends Default {
   
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();

    this._target = GetBy.class("__target", this.container)[0];
    this._containerFigure = GetBy.class("block-media", this.container)[0];
    this._figure = GetBy.class("__figure", this.container)[0];
    this._image = GetBy.selector("img", this.container)[0] || GetBy.selector("video", this.container)[0];
    this.scaleTo = 0;
    this.offsetY = 0;
    this.size = {
      width: 0,
      height: 0
    }

    this.setupAnimation();
  }

  setupAnimation() {
    let delay = 0;
    let cont = 0;
    let index = 0;
    this.timeline = gsap.timeline({ paused: true });
    [...GetBy.class("__ani")].map(project => {
      console.log(project)
      this.timeline.from(project, {
        alpha: 0,
        duration: .4,
        force3D: true
      }, delay);
      //delay += .02;
      delay += .21;

      
    });
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.directShow();
      Preloader.hide(() => { 
        this.timeline.restart();
        this.afterShow();
      });
    } else {
      Wrap.directShow();
      this.timeline.restart();
      this.afterShow();
    }
  }
  
  beforeShow() {
    super.beforeShow();
  }

  afterHide() {
    super.afterHide();
  }

  loop() {
    console.log(Scroll.engine.progress)

    const progress = Maths.normalize(.1, 0, Scroll.engine.progress);
    const scale = Math.min(this.scaleTo+.1, Maths.lerp(1, this.scaleTo, progress));
    const scaleImage = Math.max(1, Maths.lerp(2, 1.2, Scroll.engine.progress));
    const y = Math.min(this.offsetY, Maths.lerp(0, this.offsetY , Math.min(1,progress)));
    const progressBlur = Maths.normalize(1, .15, Scroll.engine.progress);
    const blur = Math.max(0, Maths.lerp(0, 20, progressBlur));

    this._containerFigure.style.transform = CSS.translate3D(0,y,-1);
    this._figure.style.transform = CSS.scale3D(scale,scale,scale);
    this._image.style.transform = CSS.scale3D(scaleImage,scaleImage,scaleImage);
    this._figure.style.setProperty('--blur', `${blur}px`);
  }

  resize() {
    super.resize();

    const h = Metrics.WIDTH * .09;
    const { x, y, width, height } = this._target.getBoundingClientRect();
    const centerY = Metrics.CENTER_Y - h * .5;

    this.offsetY = centerY - y;

    this.size = {
      width: width,
      height: h
    }

    this.scaleTo = Math.max(Metrics.WIDTH/this.size.width, Metrics.HEIGHT/this.size.height);
    
  }
}

ControllerPage._addPage("page-about", About)
